import { writable } from 'svelte/store';

export const activeView = {
  HAS_NOT_JOINED: 1,
  JOIN_CHAT: 2,
  ANONYMOUS_LOGIN: 3,
  SUMO_LOGIN: 4,
  SUMO_LOGIN_ALIAS: 5,
  CHAT_RULES: 6,
};

let state = {
  username: '',
  password: '',
  chatAlias: '',
  tempChatAlias: '',
  errorMessage: '',
  activeView: activeView.HAS_NOT_JOINED
};

export const loginStore = createState();

function createState() {
  const { subscribe, update, set } = writable(state);
  return {
    subscribe,
    update,
    set,
    setActiveView: (view) => {
      update((s) => ({ ...s, activeView: view, errorMessage: '' }));
    },
    close: () => {
      update((s) => ({ ...state }));
    },
    setErrorMessage: (error) => {
      update((s) => ({ ...s, errorMessage: error }));
    }
  };
}
